module.exports = __webpack_public_path__ + "img/img-3-9mobile.f89d43dc.png";